<template>
  <b-row>
    <b-col>
      <b-row
        align-h="between"
        class="mb-50"
      >
        <b-col cols="10">
          <h4 style="margin-left: 8rem;text-align: center;">
            Índice geral de empresas</h4>
        </b-col>
        <b-col
          cols="auto"
        >
          <b-btn
            v-b-tooltip.hover
            title="Download planilha"
            variant="none"
            @click="gerarDados"
          >
            <font-awesome-icon
              :icon="faDownload"
            />
          </b-btn>
          <a
            id="download"
            download
            href=""
            hidden
          />
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="auto">
          <vue-apex-charts
            v-if="carregado"
            class="indiceEmpresa"
            type="donut"
            :series="series"
            :options="chartOptions"
            :height="'160'"
          />
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        class="mt-1"
      >
        <b-col cols="4">
          <div class="legenda">
            <div
              style="background-color: #5fad56;"
              class="square"
            />
            <h5>Ativas</h5>
          </div>
          <div>
            <span>{{ dado.totalEmpresasAtivas }}</span>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="legenda">
            <div
              style="background-color: #d62839;"
              class="square"
            />
            <h5>Inativas</h5>
          </div>
          <div>
            <span>{{ dado.totalEmpresasInativas }}</span>
          </div>
        </b-col>
        <b-col cols="2">
          <div>
            <h5>Total</h5>
            <span>{{ dado.totalEmpresas }}</span>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.square {
  height: 15px;
  width: 15px;
  margin-right: 0.5rem;
}

.legenda {
  display: flex;
  align-items: baseline;
}

.indiceEmpresa .apexcharts-tooltip {
  color: rgb(0, 0, 0);
  font-family: inherit;
  font-weight: 400;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faDownload,
} from '@fortawesome/free-solid-svg-icons'
import VueApexCharts from 'vue-apexcharts'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'IndiceEmpresas',
  components: {
    FontAwesomeIcon,
    VueApexCharts,
  },
  data() {
    return {
      faDownload,
      carregado: false,
      dado: {},
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          height: '160',
          width: '100%',
        },
        stroke: {
          colors: ['#000000'],
          width: 0.3,
        },
        colors: ['#5fad56', '#d62839'],
        dataLabels: {
          enabled: false,
        },
        labels: ['Ativas', 'Inativas'],
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val, v) => {
              const label = v.config.labels[v.dataPointIndex]
              if (label === 'Ativas') {
                return this.dado.totalEmpresasAtivas
              }
              return this.dado.totalEmpresasInativas
            },
            title: {
              formatter: val => `${val}:`,
            },
          },
        },
      },
      campos: ['Razão Social', 'Inscrição', 'Equipe'],
    }
  },
  created() {
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getEmpresasAtivasInativas()
        .then(payload => {
          this.dado = payload.data
          this.series = payload.data.empresas
          this.carregado = true
        })
    },
    gerarDados() {
      this.$isLoading(true)
      api.gerarPlanilhaEmpresas(this.campos)
        .then(payload => {
          if (payload.data.url !== '') {
            document.getElementById('download').href = payload.data.url
            document.getElementById('download').click()
          }
          this.deletarUpload(payload.data.fileName)
        })
        .catch(err => {
          this.$isLoading(true)
          this.$erro(err)
          throw err
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(() => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
          })
      }, 3000)
    },
  },
}
</script>
